async function getMerkleProof({ merkleRoot, userAddress }) {
  const { instance, expectMerkleProvider } = this;
  return instance.idempotentCachedCall(`merkle-proof-${merkleRoot}-${userAddress}`, async function getMerkleProof2() {
    return expectMerkleProvider().merkleProof({ merkleRoot, userAddress });
  });
}

export { getMerkleProof };
